import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function compareFieldsValidator(firstControlName: string, secondControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const firstControlValue = control.get(firstControlName)?.value;
    const secondControlValue = control.get(secondControlName)?.value;
    const isValid = firstControlValue === secondControlValue;
    return isValid ? null : { compareFields: {
        firstControlValue,
        secondControlValue,
      } };
  };
}
